const articleFooter = () => {
    const selectors = {
        shareIcon: '[data-share-article]',
        shareIconToggle: '[data-share-article-toggle]',
        articleTitle: 'data-article-title',
        articleURL: 'data-article-url',
    };
    const classes = {
        shareIconsActive: 'article-footer__share--active',
    };
    const shareIcon = document.querySelector('[data-share-article]');
    const shareToggles = shareIcon.querySelectorAll(selectors.shareIconToggle);
    if (shareIcon) {
        const articleTitle = shareIcon.getAttribute(selectors.articleTitle);
        const articleURL = shareIcon.getAttribute(selectors.articleURL);
        shareToggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                if (navigator.share) {
                    navigator
                        .share({
                        title: articleTitle,
                        url: articleURL,
                    })
                        .then(() => {
                        // console.log('Thanks for sharing!');
                    })
                        .catch(console.error);
                }
                else {
                    shareIcon.classList.toggle(classes.shareIconsActive);
                }
            });
        });
    }
};
export { articleFooter };
